export const LOAD_MENU_ITEMS = '[MENU_ITEM]: Load menu items';
export const CHANGE_ITEMS = '[MENU_ITEM]: Change menu items';
